// DeleteCustomer.tsx

import React from "react";
import { Modal, Group, Button, Text } from "@mantine/core";
import classes from "./enable.module.css"; // Make sure to adjust the import path
import { RowDataMember } from "../MemberPage/types";

interface EnableFastPassProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedRow: RowDataMember | null;
}

const EnableFastPass: React.FC<EnableFastPassProps> = ({
  isOpen,
  onClose,
  onConfirm,
  selectedRow,
}) => {
  return (
    <Modal opened={isOpen} onClose={onClose} title={
    <div style={{ textAlign: "center", fontWeight: "bold" }}>
        Enable Fast Pass{" "}
    </div>}>
        <Text className={classes.title}>
            Are you sure you want to enable Membership Fast Pass for <span style={{fontWeight: 'bold'}}>{selectedRow?.name}</span>?
        </Text>
        <Text className={classes.title}>
            <span style={{fontWeight: 'bold'}}>This action cannot be revert!</span>
        </Text>
        <Group className={classes.buttonPart}>
            <Button onClick={onClose} className={classes.buttonCancel}>
            Cancel
            </Button>
            <Button onClick={onConfirm} className={classes.buttonEnable}>
            Enable
            </Button>
        </Group>
    </Modal>
  );
};

export default EnableFastPass;
